(function () {
  "use strict";

  class ValueListCurrentChange {
    constructor(wrap) {
      this.wrap = wrap;
      this.items = wrap.querySelectorAll('.js-valuList-focus-item');
      this.currentClass = "is-current";
      this.scrollHandler = this.onScroll.bind(this);

      this.init();
    }

    init() {
      window.addEventListener('scroll', this.scrollHandler);
      window.addEventListener('resize', this.scrollHandler);
      this.onScroll(); // 初回チェック
    }

    onScroll() {
      const targetLine = window.innerHeight * 2 / 3;
      const threshold = 50; // ±誤差許容範囲

      this.items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;
        const distance = Math.abs(itemCenter - targetLine);

        if (distance <= threshold) {
          item.classList.add(this.currentClass);
        }
      });
    }
  }

  const valueList = document.querySelector(".js-valuList-focus");
  if (valueList) {
    new ValueListCurrentChange(valueList);
  }
})();
